import { useNavigate } from 'react-router-dom';
import { CabeceraPagina } from '../components/Armazon';
import { Aviso, Cargando, PildoraLibre, Tarjeta, Vacio } from '../components/ui';
import { api } from '../lib/api';
import { franja } from '../lib/formato';
import { useDatos } from '../lib/sesion';

interface Pendiente {
  id: string;
  publicCode: string;
  finalStart: string | null;
  finalEnd: string | null;
  kitchenPlanStatus: 'PENDING' | 'CONFIRMED';
  client: { id: string; name: string; city: string | null };
  owner: { id: string; name: string };
}

export function Cocina() {
  const navegar = useNavigate();
  const { datos, cargando, error } = useDatos(
    (s) => api.get<{ rows: Pendiente[] }>('/kitchen/pending', s),
    [],
  );

  return (
    <>
      <CabeceraPagina
        titulo="Cocina"
      />

      {error && <Aviso tono="error">{error}</Aviso>}

      <Tarjeta sinRelleno>
        {cargando ? (
          <Cargando />
        ) : datos?.rows.length ? (
          <table className="tabla">
            <thead>
              <tr>
                <th>Visita</th>
                <th>Cliente</th>
                <th>Comercial</th>
                <th>Cuándo</th>
                <th>Plan</th>
              </tr>
            </thead>
            <tbody>
              {datos.rows.map((r) => (
                <tr key={r.id} data-clicable="true" onClick={() => navegar(`/solicitudes/${r.id}`)}>
                  <td className="codigo">{r.publicCode}</td>
                  <td>
                    <div style={{ fontWeight: 500 }}>{r.client.name}</div>
                    <div className="sutil">{r.client.city ?? '—'}</div>
                  </td>
                  <td className="sutil">{r.owner.name}</td>
                  <td className="dato" style={{ fontSize: 13 }}>
                    {franja(r.finalStart, r.finalEnd)}
                  </td>
                  <td>
                    <PildoraLibre
                      texto={r.kitchenPlanStatus === 'CONFIRMED' ? 'Confirmado' : 'Pendiente'}
                      tono={r.kitchenPlanStatus === 'CONFIRMED' ? 'hecho' : 'espera'}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <Vacio titulo="No hay visitas pendientes" />
        )}
      </Tarjeta>
    </>
  );
}
